export const COOKIE_EXPIRATION_DAYS = 365
